import React from "react";

interface PlaceholderImageProps {
  width?: number;
  height?: number;
  borderRadius?: number;
}

const PlaceholderImage: React.FC<PlaceholderImageProps> = ({
  width = 200,
  height = 200,
  borderRadius = 10,
}) => {
  const placeholderStyle: React.CSSProperties = {
    width: `${width}px`,
    height: `${height}px`,
    background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
    backgroundSize: "200% 100%",
    animation: "placeholderShimmer 1.5s infinite",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: `${borderRadius}px`,
    position: "relative",
  };

  return (
    <div style={placeholderStyle}>
      <svg
        width="50"
        height="50"
        viewBox="0 0 24 24"
        fill="none"
        stroke="gray"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="12" r="10"></circle>
        <path d="M8 15l4-4 4 4"></path>
      </svg>
      <style>
        {`
          @keyframes placeholderShimmer {
            0% { background-position: -200% 0; }
            100% { background-position: 200% 0; }
          }
        `}
      </style>
    </div>
  );
};

export default PlaceholderImage;
